export default {
      id: "single_bed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.845ff42f.svg#single_bed",
      toString: function () {
        return this.url;
      }
    }